import { useI18n } from "@wato/i18n/react";
import { Button, HelpPopover, SparklesIcon } from "@wato/ui";
import { AssistantTodaySuggestions } from "../owner-assistant/AssistantTodaySuggestions";
import { useOwnerAssistant } from "../owner-assistant/OwnerAssistantProvider";
import { HOME_QUESTION_KEYS } from "../owner-assistant/suggested-questions";

/** OWN-163: Home entry to the owner assistant — example questions open the panel and ask. */
export function HomeAssistantCard({ workspaceId }: { readonly workspaceId: string }) {
  const { t } = useI18n();
  const { ask, setOpen } = useOwnerAssistant();
  return (
    <section
      aria-label={t("dashboard.ownerAssistant.home.title")}
      data-testid="home-assistant-card"
      className="flex flex-col gap-3 rounded-lg bg-surface p-4 shadow-sm"
    >
      <div className="flex items-center justify-between gap-2">
        <div className="flex items-center gap-1">
          <h3 className="text-lg font-semibold text-fg">
            {t("dashboard.ownerAssistant.home.title")}
          </h3>
          <HelpPopover testId="home-assistant-help">
            <p className="m-0">{t("dashboard.ownerAssistant.home.lead")}</p>
            <p className="m-0 mt-2 text-xs">{t("dashboard.ownerAssistant.home.examplesLabel")}</p>
          </HelpPopover>
        </div>
        <Button
          size="sm"
          variant="secondary"
          startIcon={<SparklesIcon className="size-4" />}
          onClick={() => setOpen(true)}
        >
          {t("dashboard.ownerAssistant.home.openCta")}
        </Button>
      </div>
      <div className="flex flex-col gap-2">
        <ul className="m-0 flex list-none flex-wrap gap-2 p-0">
          {HOME_QUESTION_KEYS.map((k) => (
            <li key={k}>
              <Button
                variant="secondary"
                size="sm"
                data-testid="home-assistant-example"
                className="h-auto! whitespace-normal! py-1.5 text-start"
                onClick={() => ask(t(k))}
              >
                {t(k)}
              </Button>
            </li>
          ))}
        </ul>
      </div>
      <AssistantTodaySuggestions workspaceId={workspaceId} />
    </section>
  );
}
